const currentLocale = "ru-Ru";
export const getNumberInfo = (num, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
    const formatter = new Intl.NumberFormat(currentLocale, {
        minimumFractionDigits,
        maximumFractionDigits
    });
    const formatterParts = new Intl.NumberFormat(currentLocale, {
        minimumFractionDigits,
        maximumFractionDigits,
        signDisplay: "exceptZero"
    });
    const full = formatter.format(num);
    const parts = formatterParts.formatToParts(num);
    let integer = "";
    let fractional = "";
    let decimalSeparator = "";
    let sign = "";
    let isIntegerPart = true;
    parts.forEach(part => {
        switch (part.type) {
            case "minusSign": {
                sign = part.value ? "-" : "";
                break;
            }
            case "integer": {
                integer += part.value;
                break;
            }
            case "decimal": {
                decimalSeparator = part.value;
                isIntegerPart = false;
                break;
            }
            case "fraction": {
                fractional = part.value;
                break;
            }
            default: {
                if (part.type === "group" && isIntegerPart) {
                    integer += part.value;
                }
            }
        }
    });
    return {
        full,
        integer,
        fractional,
        decimalSeparator,
        sign
    };
};
